import { Component, Inject, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { LOCAL_STORAGE, WebStorageService } from "ngx-webstorage-service";
import { GlobalVariable } from "../../../app.component";
import { DataService } from "./../../../dataService/data.service";
import { CommonService } from "./../../../services/common.service";

@Component({
  selector: "app-tile-analytics",
  templateUrl: "./tile-analytics.component.html",
  styleUrls: ["./tile-analytics.component.scss"],
})
export class TileAnalyticsComponent implements OnInit {
  public loading = false;
  private BASE_URL = GlobalVariable;
  appointmentSourceDetails: any;
  showSourceDetails: boolean;
  outlet_id: string;
  constructor(
    private router: Router,
    private HttpService: DataService,
    private commonService: CommonService,
    @Inject(LOCAL_STORAGE) private storage: WebStorageService
  ) {}

  ngOnInit() {
    this.loading = true;
    this.outlet_id = this.storage.get("outlet_id");
    console.log(this.router.url);
    if (this.router.url === "/dashboard/mystore") {
    } else if (this.router.url === "/dashboard/appointments") {
      this.getAppointmentDetails();
    }
  }

  getAppointmentDetails() {
    // let res: Response;
    this.commonService.appointment_top_panel.subscribe((res: any) => {
      if (res) {
        if (res.code === 200) {
          this.appointmentSourceDetails = {
            source_zceppa: res.data.zceppa_appointments,
            // source_other: res.data.other_appointments,
            source_google: res.data.google_appointments,
            source_facebook: res.data.facebook_appointments,
          };
          this.loading = false;
          this.showSourceDetails =
            Object.values(this.appointmentSourceDetails).filter(
              (item) => item > 0
            ).length >= 2;
        }
      }
    });
  }
}
